/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { TMessengerChannel } from "apis/visitors/type";
import { theme } from "styles/theme";

const ChannelItem = ({ channel, isMessengerConnected=true, onDelete }: { channel: TMessengerChannel; isMessengerConnected: boolean; onDelete: (value: TMessengerChannel) => void }) => {
    return (
        <div
            css={css`
                display: flex;
                gap: 20px;
                align-items: center;
                padding: 20px 24px;
                border-bottom: 1px solid ${theme.neutral100};
            `}
        >
            <p
                css={css`
                    font-weight: 500;
                    font-size: 14px;
                    color: ${isMessengerConnected ? theme.neutral900 : theme.neutral300}; 
                `}
            >
                {channel.channelName}
            </p>
            <p
                css={css`
                   font-size: 12px;
                   font-weight: 500;
                   color: ${theme.font.destructive}; 
                   margin-left: auto;
                `}
            >
                {
                    !isMessengerConnected ? "미연동" : ""
                }
            </p>
            <p
                onClick={() => onDelete(channel)}
                css={css`
                    color: ${theme.primary500};
                    margin-left: 40px;
                    font-weight: 600;
                    font-size: 14px;
                    cursor: pointer;
                    &:hover {
                        font-weight: 800;
                    }
                `}
            >
                삭제하기
            </p>
        </div>
    );
};

export default ChannelItem;
